import { render, staticRenderFns } from "./PaymentInfoRow.vue?vue&type=template&id=90385340&scoped=true"
import script from "./PaymentInfoRow.vue?vue&type=script&lang=js"
export * from "./PaymentInfoRow.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoRow.vue?vue&type=style&index=0&id=90385340&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90385340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90385340')) {
      api.createRecord('90385340', component.options)
    } else {
      api.reload('90385340', component.options)
    }
    module.hot.accept("./PaymentInfoRow.vue?vue&type=template&id=90385340&scoped=true", function () {
      api.rerender('90385340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentInfoRow.vue"
export default component.exports